import { Component, Input } from '@angular/core';

@Component({
    selector: 'apc-navbar-big',
    templateUrl: './navbar-big.component.html',
    styleUrls: ['./navbar-big.component.scss'],
    standalone: false
})
export class NavbarBigComponent {
  @Input() public items: any[] = [];
  @Input() public color: string = "";
  @Input() public permission: string = "";
}
